import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {reserveRoutes} from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, TextInput, DateInput, RadioInput } from '../../components/common/components'
import { setFormValue, getReserveType,  getReserveDate, getReserveTime, setOptionLoading,loadPreviousVaccineData   } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import { doPost } from '../../utils/AjaxRequests'
import { apiPrefixUrl } from '../../utils/connection'


const resetReserveType = (dispatch)=>{
    dispatch(setFormValue({
        field: 'reserveType',
        value: ''
    }))
    dispatch(getReserveType())
}

const resetReserveDate = (dispatch)=>{
    dispatch(setFormValue({
        field: 'reserveDate',
        value: ''
    }))
    dispatch(getReserveDate())
}

const resetReserveTime = (dispatch)=>{
    dispatch(setFormValue({
        field: 'reserveTimeId',
        value: ''
    }))
    dispatch(getReserveTime())
}


export default function Reserve() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    const handlechange = useCallback((field, value) => {

        const preForm = _.cloneDeep(form)

        const inputValue = field === "PAT_IDNO"?value.toUpperCase():value

        dispatch(setFormValue({
            field,
            value:inputValue
        }))

        if (field === 'conformId' && value !== preForm[field]) {
            resetReserveType(dispatch)
            resetReserveDate(dispatch)
            resetReserveTime(dispatch)
        }


        if ((field === 'reserveType' || field ==="DOSAGE_COUNT" ||  (field === "PRE_VACCINE_DATE" && (value &&value.length === 8 ))) && value !== preForm[field]) {
            resetReserveDate(dispatch)
            resetReserveTime(dispatch)
        }

        if (field === 'reserveDate' && value !== preForm[field]) {
            resetReserveTime(dispatch)
        }

        // if(field === 'conformId' && value !== "C01" ){
        //     dispatch(setFormValue({
        //         field:'OCC_TITLE',
        //         value:""
        //     }))
        // }


        if(field === "DOSAGE_COUNT" && value==="1"){
            
            dispatch(setFormValue({
                field:'PRE_VACCINE_TYPE',
                value:""
            }))
            dispatch(setFormValue({
                field:'PRE_VACCINE_DATE',
                value:null
            }))
        }

        if((field === "BIRTHDAY" && (value && value.length===8))||(field === "PAT_IDNO" &&(value && value.length>9))){
            dispatch(loadPreviousVaccineData()) 
        }



    }, [dispatch, form])


    const handleNextClick = () => {

        // if(form.conformId === "C01" && !form.OCC_TITLE){
        //     Swal.fire("請選擇職業別", "", "error")
        //     return
        // }


        if (!form.reserveType) {
            Swal.fire("請選擇疫苗種類", "", "error")
            return
        }

        if (!form.DOSAGE_COUNT) {
            Swal.fire("請選擇預約施打第幾劑", "", "error")
            return
        }

        // if (form.DOSAGE_COUNT==="2" && !form.PRE_VACCINE_TYPE) {
        //     Swal.fire("請選擇第一劑施打品牌", "", "error")
        //     return
        // }

        if ((form.DOSAGE_COUNT==="2" || form.DOSAGE_COUNT==="3" || form.DOSAGE_COUNT==="3B" || form.DOSAGE_COUNT==="B2"||form.DOSAGE_COUNT === "B3"||form.DOSAGE_COUNT === "B4") && !form.PRE_VACCINE_DATE) {
            Swal.fire("請選擇前一劑施打日期", "", "error")
            return
        }


        if (!form.reserveDate) {
            Swal.fire("請選擇預約日期", "", "error")
            return
        }

        if (!form.reserveTimeId) {
            Swal.fire("請選擇預約時間", "", "error")
            return
        }

        if (!form.BIRTHDAY) {
            Swal.fire("請選擇出生年月日", "", "error")
            return
        }

        if (!form.PAT_IDNO) {
            Swal.fire("請選擇身分證字號", "", "error")
            return
        }

        let payload = {	
            "api":"CDCChecker",
            "SCHD_ID":form.reserveTimeId,
            "PAT_IDNO": form.PAT_IDNO,
            "BIRTHDAY":form.BIRTHDAY,
            "CONFORM_TYPE":form.conformId,
            "SPNO":"",
            "DOSAGE_COUNT":form.DOSAGE_COUNT,
            "USER_ID":"patient"
        }
        dispatch(setOptionLoading({loading:true}))
        doPost(apiPrefixUrl, payload)
        .then((rdata)=>{
            if(rdata.status){
                if(rdata.data.pass === "Y"){
                    Swal.fire(rdata.data.msg,"","success")
                    history.push('/second_step')
                }else{
                    Swal.fire(rdata.data.msg,"","error")
                }                

                dispatch(setOptionLoading({loading:false}))
            }else{
                Swal.fire(rdata.err,"","error")
                dispatch(setOptionLoading({loading:false}))
            }
        })
        .catch((e)=>{
            Swal.fire("系統錯誤","","error")
            dispatch(setOptionLoading({loading:false}))
        })


    }

    if(option.conform.length === 0){
        return <div>loading...</div>
    }

    let reserveTypeData = _.find(option.reserveType, (o)=>{
        return o.value === form.reserveType
    })


    return <Box className={layoutClasses.page}>        
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar/>
        {/* <Typography style={{paddingBottom:"10px"}}>
            依據主管機關通知，「COVID-19疫苗接種」自2023年5月1日起由合約醫療院所收取掛號費提供接種，
            故本次接種將收取掛號費200元
        </Typography> */}
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            <SelectInput
                label="接種對象類別"
                field="conformId"
                value={form.conformId}
                setValue={handlechange}
                options={JSON.stringify(option.conform)}
            />

            {/* {form.conformId === "C01"?
            <div style={{padding:"0px 10px"}}>
            <p style={{color:"red", fontSize:"16px", margin:"0px"}}>接種當日需提供本院識別證或醫事執業登記</p>
           
            </div>:null}

            {["C02","C03", "C04", "C05"].indexOf(form.conformId) >-1?
            <div style={{padding:"0px 10px"}}>
            <p style={{color:"red", fontSize:"16px", margin:"0px"}}>接種當日需提供工作證件</p>
           
            </div>:null}

            {form.conformId === "C12"?
            <div style={{padding:"0px 10px"}}>
            <p style={{color:"red", fontSize:"16px", margin:"0px"}}>Novavax疫苗第二次追加劑接種當日需提供工作邀請證明及機票</p>
           
            </div>:null} */}



            <DateInput
                label="出生年月日"
                field="BIRTHDAY"
                setValue={handlechange}
                value={form.BIRTHDAY}
                variant="outlined"
            />
            <TextInput
                label="身分證字號"
                field="PAT_IDNO"
                value={form.PAT_IDNO}
                setValue={handlechange}
                variant="outlined"
            />
            <SelectInput
                label="疫苗種類"
                field="reserveType"
                value={form.reserveType}
                setValue={handlechange}
                options={JSON.stringify(option.reserveType)}
            />
            <SelectInput
                label={`預約施打${reserveTypeData?reserveTypeData.label:""}第幾劑`}
                field="DOSAGE_COUNT"
                value={form.DOSAGE_COUNT}
                setValue={handlechange}
                options={JSON.stringify([
                {"value":"1", "label":"一"}, 
                {"value":"2", "label":"二"},               
                {"value":"3", "label":"三"}
            ])}
                // variant="standard"
            />
    
            {form.DOSAGE_COUNT === "2"||form.DOSAGE_COUNT === "3"||form.DOSAGE_COUNT === "3B" ||form.DOSAGE_COUNT === "B2"||form.DOSAGE_COUNT === "B3"||form.DOSAGE_COUNT === "B4"?
            <>
                {/* <SelectInput
                    label="第一劑施打品牌"
                    field="PRE_VACCINE_TYPE"
                    value={form.PRE_VACCINE_TYPE}
                    setValue={handlechange}
                    options={JSON.stringify(option.vaccine)}
                    // variant="standard"
                /> */}
                {/* <p style={{color:"red", marginLeft:"10px"}}>依據指揮中心決議：不同廠牌 COVID-19 疫苗原則不建議交替使用。</p> */}
                <DateInput
                    label={`${reserveTypeData?reserveTypeData.label:""}前一劑施打日期`}
                    field="PRE_VACCINE_DATE"
                    setValue={handlechange}
                    value={form.PRE_VACCINE_DATE}
                    variant="outlined"
                />
            </>:null}

            <SelectInput
                label="預約接種日期"
                field="reserveDate"
                value={form.reserveDate}
                setValue={handlechange}
                options={JSON.stringify(option.reserveDate)}
            />
            <SelectInput
                label="預約接種時段"
                field="reserveTimeId"
                value={form.reserveTimeId}
                setValue={handlechange}
                options={JSON.stringify(option.reserveTime)}
            />
          

            {option.loading?
            <div style={{
                position:"absolute", 
                left:0, 
                right:0, 
                top:0, 
                bottom:0, 
                backgroundColor:"rgba(0,0,0,0.3)",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
            }}>
                <CircularProgress size={200}/>
            </div>:null}
        </Paper>
        {option.loading?null:
        <Button
            variant="contained"
            color="primary"
            style={{ margin: "30px auto" }}
            onClick={() => { handleNextClick() }}
        >
            下一步
        </Button>}
    </Box>
}